import {
    FilePdfFilled,
    FileProtectOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import { Button, ConfigProvider, DatePicker, Modal, Tag, Slider, Space, Spin, Switch, Table, Select, Row, Col } from "antd";
import frFR from "antd/locale/fr_FR";
import jsPDF from "jspdf";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { rightsService } from "../../../services/rightsService";
import { LOGGED_USER } from "../../../variables/constants";
import { frenchDate, frenchDateSimple } from "../../../variables/functions";
import AttestationMotoToPrint from "../components/docs/AttestationMotoToPrint";
import AttestationMoto from '../components/docs/AttestationMoto';



import axiosInstance from "../../../variables/api/axiosInstance";
import DTRFWPPFormatToPrint from "../components/docs/DTRFWPPFormatToPrint";
import { toast } from "react-toastify";
import { displayNumbers } from "../../../variables/numbersFunctions";
import { StatCard } from "../../../components/statistics/StatCard";
import { COLORS } from "../../../components/ui/colors";


const { RangePicker } = DatePicker;
const dateFormat = "DD/MM/YYYY";

const PrintedContracts = () => {
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, showSizeChanger: true });
    const [canceledContract, setCanceledContract] = useState(0);
    const [activeContract, setActiveContract] = useState(0);
    const [devis, setDevis] = useState(0);
    const [data, setData] = useState([]);
    const [selecting, setSelecting] = useState(false);
    const [hidden, setHidden] = useState(false);
    const [selectedContrats, setSelectedContrats] = useState([]);
    const [loadingContrats, setLoadingContrats] = useState(true);
    const [loading, setLoading] = useState(false);
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [numAttestationModal, setNumAttestationModal] = useState(false);
    const [printingAttestation, setPrintingAttestation] = useState(false);
    const [numeroAttestations, setNumeroAttestations] = useState([]);
    const [banques, setBanques] = useState([]);
    const [currentContractIndex, setCurrentContractIndex] = useState(0);
    const [selectedDate, setSelectedDate] = useState(null);
    const [hiddenAttestation, setHiddenAttestation] = useState(false);
    const [concessionnaire, setConcessionnaire] = useState("");
    const [concessionnaires, setConcessionnaires] = useState([]);

    const printRef = useRef();

    const attestationRef = useRef();

    const navigate = useNavigate();

    const [layout, setLayout] = useState("portrait"); // Default layout

    useEffect(() => {
        // Remove any previously injected styles
        document.querySelectorAll("link[data-print-style]").forEach((el) => el.remove());

        // Create a new link element for the selected CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = layout === "portrait" ? "/portrait.css" : "/landscape.css";
        link.setAttribute("data-print-style", "true");

        document.head.appendChild(link);
    }, [layout]);
    const handleChange = (pagination, filters, sorter) => {
        setPagination(pagination);
        setPageSize(pagination.pageSize);
        setCurrentPage(pagination.current);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const attestationRefs = useRef(selectedContrats.map(() => React.createRef()));

    const columns = [
        {
            title: "Numero de police",
            dataIndex: "numeroPolice",
            key: "1",
        },
        {
            title: "Souscripteur",
            dataIndex: "souscripteur",
            key: "2",
        },
        {
            title: "Immatriculation",
            dataIndex: "immatriculation",
            key: "3",
        },
        {
            title: "Date Effet",
            dataIndex: "dateEffet",
            key: "4",
        },
        {
            title: "Date Echeance",
            dataIndex: "dateEcheance",
            key: "5",
        },
        {
            title: "Statut reglement",
            dataIndex: "regle",
            key: "regle",
            render: (_, record) => (
                <>
                    {record.regle === "REGLE" ? (
                        <Tag color="success" key={_}>
                            REGLE
                        </Tag>
                    ) : (
                        <Tag color="blue" key={_}>
                            NON REGLE
                        </Tag>
                    )}
                </>
            ),
            filters: [
                {
                    text: "REGLE",
                    value: "REGLE",
                },
                {
                    text: "NON REGLE",
                    value: "NON REGLE",
                },
            ],
            filteredValue: filteredInfo.regle || null,
            onFilter: (value, record) => record.regle === value,
            sorter: (a, b) => a.regle.length - b.regle.length,
            sortOrder: sortedInfo.columnKey === "regle" ? sortedInfo.order : null,
            ellipsis: true,
        },
        Table.EXPAND_COLUMN,
        {
            title: "Actions",
            dataIndex: "actions",
            key: "7",
            render: (_, record) => (
                <>
                    <button
                        type="button"
                        class="btn btn-primary btn-icon rounded-pill"
                        onClick={() => navigate(`/details-contrat/${record.codeId}`)}
                    >
                        <i class="bx bx-dots-vertical-rounded"></i>
                    </button>
                    {/*{rightsService("HCO006") && record.numeroPolice &&*/}
                    {/*  <button type="button" class="btn btn-danger btn-icon rounded-pill">*/}
                    {/*    <i class="bx bxs-file-pdf"></i>*/}
                    {/*  </button>}*/}
                </>
            ),
        },
    ];

    const MyFooter = () => {
        let rCtrts = selectedRows.filter((ctr) => ctr.regle === "REGLE");

        return (
            <div class="row">
                <>
                    <div class="col-sm-4">
                        <Button
                            onClick={() => {
                                setLayout("portrait");
                                setSelectedContrats(rCtrts);
                                exportToPdfs(rCtrts);
                            }}
                            color="primary"
                            style={{ color: "green" }}
                            icon={<FilePdfFilled />}
                        >
                            Imprimer C.P.
                        </Button>
                    </div>
                    <div class="col-sm-4">
                        <Button
                            onClick={() => {
                                setLayout("landscape");
                                exportAttestations(rCtrts);
                            }}
                            color="primary"
                            style={{ color: "blue" }}
                            icon={<FileProtectOutlined />}
                        >
                            Imprimer Attestation
                        </Button>
                    </div>
                </>

            </div>
        );
    };

    const fetchContracts = async (params = {}) => {
        setLoadingContrats(true);
        try {
            await axiosInstance
                .get(`/api/contrat/printed`, {
                    params: {
                        page: params.pagination.current - 1,
                        size: params.pagination.pageSize,
                        ...params.filters,
                    },
                })
                .then((res) => {
                    const { content, totalElements } = res.data;
                    console.log("Contracts fetched: ", res.data);
                    console.log("Total element; ", totalElements);
                    let ctrs = [];
                    content.forEach((contrat, key) => {
                        ctrs.push({
                            key: contrat.codeId,
                            codeId: contrat.codeId,
                            id: key,
                            numeroPolice: contrat.numeroPoliceP
                                ? contrat.numeroPoliceP
                                : contrat.numeroPoliceM,
                            immatriculation: contrat?.immatriculation,
                            souscripteur: contrat?.prenom
                                ? `${contrat?.prenom} ${contrat?.nom}`
                                : `${contrat?.nom}`,
                            organisme: contrat?.raisonSociale,
                            dateEffet: contrat?.dateEffet
                                ? `${frenchDate(contrat?.dateEffet)}`
                                : "",
                            dateEcheance: contrat?.dateEcheance
                                ? `${frenchDateSimple(contrat?.dateEcheance)} `
                                : "",
                            regle: contrat.reglements
                                ? "REGLE"
                                : "NON REGLE",
                            data: contrat,
                        });
                    });
                    setData(ctrs);
                    setPagination({
                        ...params.pagination,
                        total: totalElements,
                    });
                    setTotal(totalElements);
                });

            await axiosInstance
                .get(`/api/contrat/concessionnaires-printed`, {
                    params: {
                        ...params.filters,
                    },
                })
                .then((res) => {
                    console.log("Concess: ", res.data);
                    setConcessionnaires(res.data);
                });
        } catch (error) {
            console.error("Error fetching contracts:", error);
        } finally {
            setLoadingContrats(false);
        }
    };


    useEffect(() => {
        if (selectedDate) {
            const startDate = selectedDate[0];
            const endDate = selectedDate[1];
            fetchContracts({
                pagination,
                filters: {
                    ...filteredInfo,
                    startDate,
                    endDate,
                    concessionnaire
                },
            });
        } else {
            fetchContracts({
                pagination,
                filteredInfo,
            });
        }

        axiosInstance
            .get(`/api/parametre/type/BANQUE`)
            .then((res) => {
                setBanques(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [loading, currentPage, pageSize, selectedDate]);


    const exportAttestations = (contrats) => {
        setNumAttestationModal(true);
        setSelectedContrats(contrats);
    };

    const exportAttestationToPdf = useReactToPrint({
        content: () => {
            const ref = attestationRefs.current[currentContractIndex];
            return ref ? ref.current : null;
        },
        onBeforeGetContent: () => setPrintingAttestation(false),
        onAfterPrint: () => {
            // Move to the next contract after the current one is printed
            setCurrentContractIndex((prevIndex) => prevIndex + 1);
        },
    });

    useEffect(() => {
        if (currentContractIndex < selectedContrats.length) {
            // Trigger the print for the next contract
            exportAttestationToPdf();
        } else {
            // Reset once all contracts have been printed
            setCurrentContractIndex(0);
        }
    }, [currentContractIndex]);

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        onAfterPrint: () => {
            let allC = [];
            allC = selectedRows.filter((ctr) => ctr.regle === "REGLE");
            console.log("Nice: ", allC);
            allC.forEach((ctrt) => {
                console.log("Selected");
                axiosInstance
                    .get(
                        `/api/contrat/impression/codeId/${ctrt.data.codeId}/${LOGGED_USER.codeId}`
                    )
                    .then((res) => {
                        console.log(res.data);
                        console.log("OK");
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            });
        },
    });

    const exportToPdfs = (contrats) => {
        setSelectedContrats(contrats);
        console.log("Contraaaats: ", contrats);
        setHidden(true);
        setTimeout(() => {
            handlePrint();
        }, [500]);
    };

    const handleAttestationPrint = useReactToPrint({
        content: () => attestationRef.current,
        onAfterPrint: () => {
            let allC = [];
            allC = selectedRows.filter((ctr) => ctr.regle === "REGLE");
            console.log("Nice: ", allC);
            allC.forEach((ctrt) => {
                console.log("Selected");
                axiosInstance
                    .get(
                        `/api/contrat/impression-attestation/${ctrt.data.codeId}/`
                    )
                    .then((res) => {
                        console.log(res.data);
                        console.log("OK att");
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            });
        },
    });

    const exportToAttestationsPdfs = (contrats) => {
        setPrintingAttestation(true);
        setSelectedContrats(contrats);
        // console.log("Contrats: ", contrats);
        setHiddenAttestation(true);
        setTimeout(() => {
            handleAttestationPrint();
        }, [500]);
    };

    const onSelectChange = (newSelectedRowKeys, rows) => {
        console.log("selectedRowKeys changed: ", newSelectedRowKeys);
        console.log("SelectedRows", rows);
        setSelectedRows(rows);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const pbStyles = {
        pageBreak: {
            pageBreakBefore: "always",
        },
    };

    const handleDateChange = (dates, dateStrings) => {
        const [sDate, eDate] = dateStrings;
        console.log(dateStrings);
        if (dateStrings[0] && dateStrings[1]) {
            const [startDay, startMonth, startYear] = sDate.split("/");
            const [endDay, endMonth, endYear] = eDate.split("/");
            const startDate = `${startYear}-${startMonth}-${startDay}`;
            const endDate = `${endYear}-${endMonth}-${endDay}`;
            console.table([startDate, endDate]);
            setSelectedDate([startDate, endDate]);
            setFilteredInfo({
                ...filteredInfo,
                startDate,
                endDate,
            });
            fetchContracts({
                pagination,
                filters: {
                    ...filteredInfo,
                    startDate,
                    endDate,
                },
            });
        } else {
            fetchContracts({
                pagination,
                filteredInfo
            });
        }

    };

    const groupContractsByConcessionnaire = (contracts) => {
        return contracts.reduce((acc, contract) => {
            const concessionnaireId =
                contract?.engins[0]?.concessionnaire?.organismeId;

            if (!acc[concessionnaireId]) {
                acc[concessionnaireId] = [];
            }
            acc[concessionnaireId].push(contract);
            return acc;
        }, {});
    };

    const fetchAllContracts = async (params = {}) => {
        setLoadingContrats(true);
        try {
            await axiosInstance
                .get(`/api/contrat/all`, {
                    params: {
                        ...params.filters,
                    },
                })
                .then((res) => {
                    if (res.data.length === 0) {
                        toast("Aucun contrat émis à cette pour cette date!");
                        return;
                    }
                    let contratsByConcessionnaires = [];
                    contratsByConcessionnaires =
                        groupContractsByConcessionnaire(res.data);
                    const doc = new jsPDF();
                    const theDate = selectedDate[0] === selectedDate[1] ? selectedDate[0] : `${selectedDate[0]}-${selectedDate[1]}}`

                    Object.keys(contratsByConcessionnaires).forEach(
                        (concessionnaireId, index) => {
                            const contracts = contratsByConcessionnaires[concessionnaireId];

                            // Sort contracts alphabetically by souscripteur name
                            const sortedContracts = [...contracts].sort((a, b) => {
                                const nameA = `${a.souscripteur.nom} ${a.souscripteur.prenom || ''}`.toLowerCase();
                                const nameB = `${b.souscripteur.nom} ${b.souscripteur.prenom || ''}`.toLowerCase();
                                return nameA.localeCompare(nameB);
                            });

                            // console.log("contract of 0: ", contracts[0]?.engins[0]?.concessionnaire);
                            const concessionnaireName =
                                contracts[0]?.engins[0]?.concessionnaire?.raisonSociale;

                            // Ajouter le nom du concessionnaire
                            doc.setFontSize(16);
                            const pageWidth = doc.internal.pageSize.getWidth();
                            console.log("Date filter", theDate);
                            const title = `LISTE DES CONTRATS DE LA JOURNEE DU ${theDate}`;
                            doc.text(title, pageWidth / 2, 10, { align: "center" });
                            doc.line(
                                (pageWidth - doc.getTextWidth(title)) / 2,
                                11,
                                (pageWidth + doc.getTextWidth(title)) / 2,
                                11,
                            );

                            doc.setFont("helvetica", "bold");
                            doc.text(`${concessionnaireName}`, pageWidth / 2, 20, {
                                align: "center",
                            });
                            doc.setFont("helvetica", "normal");
                            doc.text(
                                `Transmis le : ${selectedDate[1]}`,
                                pageWidth / 2,
                                30,
                                { align: "center" },
                            );

                            // Ajouter le tableau des contrats
                            const tableData = sortedContracts.map((contract) => [
                                {
                                    content: `${contract.souscripteur.nom} ${contract.souscripteur.prenom ? contract.souscripteur.prenom : ""}`,
                                    styles: { fontStyle: "bold" },
                                },
                                contract.engins[0].immatriculation,
                                contract.engins[0].numeroChassis,
                                contract.souscripteur?.contact[0],
                            ]);

                            doc.autoTable({
                                head: [
                                    [
                                        "Nom - Prénoms du Sollicitant",
                                        "N° Imma.",
                                        "N° Châssis",
                                        "Téléphone",
                                    ],
                                ],
                                body: tableData,
                                startY: 40,
                                theme: 'grid',
                            });

                            // Ajouter une rupture de page sauf pour le dernier concessionnaire
                            if (index < Object.keys(contratsByConcessionnaires).length - 1) {
                                doc.addPage();
                            }
                        },
                    );

                    // Enregistrer le document PDF
                    doc.save(
                        `Rapport_Journalier_PoolIns_TransportRoutier_${theDate}.pdf`,
                    );
                });
        } catch (error) {
            console.error("Error fetching contracts:", error);
        } finally {
            setLoadingContrats(false);
        }
    };

    const generateTFJDTRFByConcessionnaire = () => {
        if (selectedDate) {
            console.log("Date ", selectedDate);
            fetchAllContracts({
                filters: {
                    startDate: selectedDate[0],
                    endDate: selectedDate[1],
                },
            });
        } else {
            toast("Veuillez sélectionner une période / date");
        }
    };

    const handleConcessionnaireChange = (value) => {
        setConcessionnaire(value);
        setFilteredInfo({
            ...filteredInfo,
            concessionnaire: value,
        });
        fetchContracts({
            pagination,
            filters: {
                ...filteredInfo,
                concessionnaire: value,
            },
        });
    };


    return (
        <div class="layout-wrapper layout-content-navbar  ">
            <div class="layout-container">
                <SideBar currentMenu={"PRODUCTION"} />

                {/* <!-- Layout container --> */}
                <div class="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div class="content-wrapper">
                        {/* <!-- Content --> */}
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <Row style={{ marginBottom: "15px", justifyContent: "space-between" }}>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats"
                                        subtitle="Total contrats"
                                        value={displayNumbers(total || 0)}
                                        icon="bx bx-file"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats actifs"
                                        subtitle="Nbre total de contrats actifs"
                                        value={`${activeContract ? displayNumbers(activeContract) : 0}`}
                                        icon="bx bx-check-circle"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats annulés"
                                        subtitle="Contrats annulés"
                                        value={displayNumbers(canceledContract || 0)}
                                        icon="bx bx-x-circle"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats en attente"
                                        subtitle="Contrats en Proposition"
                                        value={displayNumbers(devis || 0)}
                                        icon="bx bx-time-five"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                            </Row>
                            {/* <!-- Users List Table --> */}
                            <div class="row">
                                <div class="col-sm-4">
                                    {rightsService("HCO022") || rightsService("HCO005") || rightsService("HCO019") ? <Button
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        style={{ marginBottom: 16, backgroundColor: COLORS.secondary, borderColor: COLORS.secondary }}
                                        onClick={() => navigate("/ajouter-contrat-new")}
                                    >
                                        Nouveau contrat
                                    </Button> : null}
                                </div>
                            </div>

                            <div class="card">
                                <div class="container">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-4">
                                                    <Space align="center" style={{ marginBottom: 16 }}>
                                                        Mode sélection:{" "}
                                                        <Switch
                                                            checked={selecting}
                                                            onChange={setSelecting}
                                                        />
                                                    </Space>
                                                </div>
                                                <div class="col-4">
                                                    <RangePicker
                                                        format={dateFormat}
                                                        onChange={handleDateChange}
                                                        placeholder="Filtre par date"
                                                    />
                                                </div>
                                                {/* <div class="col-4">
                                                    <Select
                                                        onChange={handleConcessionnaireChange}
                                                        placeholder="Filtre par concessionnaire"
                                                        options={concessionnaires?.map((conces) => ({
                                                            label: conces.raisonSociale,
                                                            value: conces.organismeId
                                                        }))}
                                                        style={{ width: "100%" }}
                                                    />
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ConfigProvider locale={frFR}>
                                    <Spin spinning={loadingContrats}>
                                        {selecting ? (
                                            <Table
                                                rowSelection={rowSelection}
                                                columns={columns}
                                                dataSource={data}
                                                onChange={handleChange}
                                                pagination={pagination}
                                                footer={() => <MyFooter />}
                                            />
                                        ) : (
                                            <Table
                                                columns={columns}
                                                dataSource={data}
                                                onChange={handleChange}
                                                pagination={pagination}
                                            />
                                        )}
                                    </Spin>
                                </ConfigProvider>
                            </div>
                            <div id="myContrat" ref={printRef}>
                                {selecting &&
                                    hidden &&
                                    selectedContrats.map((row, index) => {
                                        return (
                                            <>
                                                <DTRFWPPFormatToPrint contrat={row.data} key={index} />
                                                <div style={{ width: "210mm", height: "297mm" }}></div>
                                            </>
                                        );
                                    })}
                            </div>
                        </div>
                        <Modal
                            title="Attestation"
                            centered
                            open={numAttestationModal}
                            onOk={() => {
                                // window.location.reload();
                                setNumAttestationModal(false);
                            }}
                            onCancel={() => {
                                // window.location.reload();
                                setNumAttestationModal(false);
                            }}
                            width={1200}
                            zIndex={2000}
                        >
                            <div className="container" justify="center">
                                <div className="grid-item" lg={12} ref={attestationRef}>
                                    {selectedContrats.map((row, index) => (
                                        <div key={index}>
                                            <div>
                                                {printingAttestation ? (
                                                    <AttestationMotoToPrint
                                                        engin={row.data.engins[0]}
                                                        contrat={row.data}
                                                    />
                                                ) : (
                                                    <AttestationMoto
                                                        engin={row.data.engins[0]}
                                                        contrat={row.data}
                                                    />
                                                )}

                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                            </div>
                                            {index < selectedContrats.length - 1 ? (
                                                <div style={pbStyles.pageBreak} className="pageBreak">
                                                    <hr />
                                                </div>
                                            ) : null}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <>
                                Veuillez préciser les numéros d&apos;attestations à imprimer
                                <br />
                                <Slider
                                    range
                                    className="slider-main-div"
                                    min={10000}
                                    max={100000}
                                    onChange={(v) => {
                                        setNumeroAttestations(v);
                                        // console.log(v);
                                    }}
                                    defaultValue={[10000, 100000]}
                                    value={numeroAttestations}
                                />
                            </>
                            <br />
                            <br />
                            <Button
                                onClick={() => {
                                    // console.log("nA: ", numeroAttestations);
                                    //                  attestationPrinting();
                                    exportToAttestationsPdfs(selectedContrats);
                                }}
                                type="primary"
                                style={{
                                    background: "green",
                                }}
                            >
                                Imprimer
                            </Button>
                        </Modal>
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div class="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>
            <Spin spinning={loadingContrats}>
                <div class="buy-now">
                    <button onClick={() => generateTFJDTRFByConcessionnaire()} class="btn btn-secondary btn-buy-now">
                        Rapport journalier
                    </button>
                </div>
            </Spin>
            {/* <!-- Overlay --> */}
            <div class="layout-overlay layout-menu-toggle"></div>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div class="drag-target"></div>
        </div>
    );
};

export default PrintedContracts;
